import React, { Fragment } from "react";
import { Col, Row } from "reactstrap";
import { Link } from "react-router-dom";
import RegistrationForm from "./RegistrationForm";
import RegistrationFormNew from "./RegistrationFormNew";
import AuthWizardProvider from "../common/wizard/AuthWizardProvider";
import Payment from "./payment/Index";
import AuthCardLayout from "./AuthCardLayout";
import bgImage from "../../assets/img/logos/api-award-2022.jpg";

const Registration = () => {

  

  return (
    <>
      <AuthWizardProvider>
        <AuthCardLayout bgProps={{ image: bgImage }}>
          <Payment validation={true} />
        </AuthCardLayout>
      </AuthWizardProvider>
    </>
  );
};

export default Registration;
